import { render, staticRenderFns } from "./Radiology.vue?vue&type=template&id=1abb4e90&scoped=true"
import script from "./Radiology.vue?vue&type=script&lang=js"
export * from "./Radiology.vue?vue&type=script&lang=js"
import style0 from "./Radiology.vue?vue&type=style&index=0&id=1abb4e90&prod&scoped=true&lang=css"
import style1 from "./Radiology.vue?vue&type=style&index=1&id=1abb4e90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abb4e90",
  null
  
)

export default component.exports